/* eslint-disable no-unused-vars */
import React from "react";
import {
  TextField,
  Typography,
  FormControl,
  Grid,
  FormHelperText,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import InputMask from "@mona-health/react-input-mask";
import "./styles.scss";

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: "100%",
    marginTop: theme?.spacing(1.5),
  },
  label: {
    lineHeight: "30px",
  },
  Input: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "0",
    },
    "& .MuiInputBase-inputSizeSmall": {
      padding: theme?.spacing(1, 1.5),
      backgroundColor: "#fff",
    },
    "& .MuiOutlinedInput-root:hover .MuiInputBase-inputSizeSmall": {
      borderColor: "#B72755",
    },
    "& .MuiFormHelperText-marginDense": {
      margin: theme.spacing(0.5, 0.5, 0, 0.5),
    },
    "& .masked-input-container input.masked-input": {
      borderRadius: "0",
    },
  },
}));

export default function MaskedInput(props) {
  const {
    name,
    value,
    label,
    required,
    placeholder,
    variant = "outlined",
    error = null,
    size = "small",
    fullWidth,
    type = "",
    onChange,
    maskformat,
    inlineMask,
    disabled,
    ...others
  } = props;

  const classes = useStyles();

  return (
    <FormControl
      variant={variant}
      className={classes?.formControl}
      {...(error && { error: true })}
    >
      <Grid container spacing={0} className={inlineMask ? "inline-masked" : ""}>
        <Grid item xs={12} md={4}>
          {label && (
            <Typography
              component="p"
              className={required ? "inputLabel required" : "inputLabel"}
            >
              {label}
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} md={8}>
          {/* Wrap MUI TextField with InputMask */}
          <InputMask mask={maskformat} value={value} onChange={onChange} name={name} disabled={Boolean(disabled)}>
              <TextField
                placeholder={placeholder}
                name={name}
                type={type}
                size={size}
                value={value}
                fullWidth={fullWidth}
                className="masked-input-container"
                {...others}
                {...(error && { error: true, helperText: error })}
              />
          </InputMask>
        </Grid>
      </Grid>
    </FormControl>
  );
}
